import {create} from "zustand";

export const useConsentStore = create((set) => ({
  consent: false,
  updateConsent: (value) => set({consent: value}),
}));
